import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';
import { ErrorFallback } from '~/components/Error/ErrorFallback';

const noop = () => {};
export type QueryErrorBoundaryProps = PropsWithChildren<
  Omit<ErrorBoundaryProps, 'FallbackComponent' | 'fallbackRender'>
> &
  Partial<Pick<ErrorBoundaryProps, 'FallbackComponent' | 'fallbackRender'>>;
export const QueryErrorBoundary = ({
  onReset = noop,
  children,
  FallbackComponent = ErrorFallback,
  fallbackRender,
  fallback,
  ...props
}: QueryErrorBoundaryProps) => (
  <>
    {!!children && (
      <QueryErrorResetBoundary>
        {({ reset }) => {
          const onErrorBoundaryReset = (...args: unknown[]) => {
            reset();
            onReset(...args);
          };

          return fallbackRender ? (
            <ErrorBoundary
              fallbackRender={fallbackRender}
              {...props}
              onReset={onErrorBoundaryReset}
              onResetKeysChange={onErrorBoundaryReset}>
              {children}
            </ErrorBoundary>
          ) : (
            <ErrorBoundary
              FallbackComponent={FallbackComponent}
              {...props}
              onReset={onErrorBoundaryReset}
              onResetKeysChange={onErrorBoundaryReset}>
              {children}
            </ErrorBoundary>
          );
        }}
      </QueryErrorResetBoundary>
    )}
  </>
);
